// i18next-extract-mark-ns-start Step1

const curtainAdjustments = (t) => [
  { label: t('< 2m de large'), id: '13.ride-ret-1' },
  { label: t('2m de large ou plus'), id: '13.ride-ret-2' },
];

const curtainTapeAdjustments = (t) => [
  { label: t('< 2m de large'), id: '13.ride-ret-6' },
  { label: t('2m de large ou plus'), id: '13.ride-ret-7' },
];

const curtainRepairs = (t) => [
  { label: t('C‘est déchiré / troué'), id: '13.ride-rep-tear-1', question: { label: t('Combien y a-t-il de déchirures / de trous ?'), answer: 1 } },
];

const curtainAlterations = (t) => [
  { label: t('Ajuster la taille à mes fenêtres'), adjustments: curtainAdjustments },
  { label: t('C‘est déchiré / troué'), id: '13.ride-rep-tear-1' },
  { label: t('Faire un raccord'), id: '13.ride-ret-5' },
  { label: t('Ajouter un fil de plomb'), id: '13.ride-ret-3' },
  { label: t('Ajouter des fronces'), adjustments: curtainTapeAdjustments },
];

const curtainAlterationsPackage = (t) => [
  { label: t('C‘est trop long'), adjustments: curtainAdjustments },
  { label: t('C‘est déchiré / troué'), id: '13.ride-rep-tear-1', question: { label: t('Combien y a-t-il de déchirures / de trous ?'), answer: 1 } },
  { label: t('Faire un raccord'), id: '13.ride-ret-5' },
  { label: t('Ajouter des fronces'), adjustments: curtainTapeAdjustments },
];

const cushionAlterations = (t) => [
  { label: t('Un accroc'), id: '13.cous-rep-tear-1' },
  { label: t('Un zip'), id: '13.cous-rep-zip-1' },
  { label: t('Un bouton'), id: '13.cous-rep-but-2' },
];

const sofaAlterations = (t) => [
  { label: t('Un accroc'), id: '13.sofa-rep-tear-1' },
  { label: t('Un zip'), id: '13.sofa-rep-zip-1' },
  { label: t('Un bouton'), id: '13.sofa-rep-but-2' },
];

const chairAlterations = (t) => [
  { label: t('Un accroc'), id: '13.chair-rep-tear-1' },
  { label: t('Un zip'), id: '13.chair-rep-zip-1' },
  { label: t('Un bouton'), id: '13.chair-rep-but-2' },
];

const tableClothesAlterations = (t) => [
  { label: t('Un accroc'), id: '13.tableClothes-rep-tear-1' },
];

const embroideries = (t) => [
  { label: t('Des initiales') },
  { label: t('Un mot (10 lettres)') },
  { label: t('Un dessin') },
  { label: t('En parler en RDV') },
];

const embroideriesPackage = (t) => [
  { label: t('Un texte') },
  { label: t('Un dessin') },
];

const linensProblems = (t) => [
  { label: t('Il est abîmé') },
  { label: t('Il est trop grand') },
];

const linensAlterations = (t) => [
  {
    label: t('Il y a un accroc'),
    id: '13.mais-rep-tear-1',
    question: { label: t('Combien y a-t-il d’accrocs ?'), answer: 1 },
  },
  {
    label: t('Il manque un bouton'),
    id: '13.mais-rep-but-2',
    question: { label: t('Combien manquent-ils de boutons ?'), answer: 1 },
  },
];

const linensSizes = (t) => [
  {
    label: t('Moins d’1m'),
    widthAdjustmentId: '13.mais-ret-8',
    heightAdjustmentId: '13.mais-ret-7',
    bothAdjustmentId: '13.mais-ret-9',
  },
  {
    label: t('Moins d’1m60'),
    widthAdjustmentId: '13.mais-ret-5',
    heightAdjustmentId: '13.mais-ret-4',
    bothAdjustmentId: '13.mais-ret-6',
  },
  {
    label: t('Plus d’1m60'),
    widthAdjustmentId: '13.mais-ret-2',
    heightAdjustmentId: '13.mais-ret-1',
    bothAdjustmentId: '13.mais-ret-3',
  },
];

const linensWhere = (t) => [
  { label: t('La largeur'), slug: 'widthAdjustment' },
  { label: t('La longueur'), slug: 'heightAdjustment' },
  { label: t('Les deux'), slug: 'bothAdjustment' },
];

const getList = (items, t) => items(t).map((item) => ({ isActive: false, ...item }));

const initialState = {
  selectedCategory: undefined,
  selectedCloth: '',
  selectedPiece: '',
  selectedAccessory: '',
  selectedShoes: '',
  creationSlug: '',
  creationShape: {},
  selectedCreationNumberOfPieces: 1,
  creationSize: {},
  creationHeight: {},
  creationFirstOption: {},
  creationSecondOption: {},
  selectedProblems: {},
  selectedLining: '',
  numberOfPieces: 1,
  isCurtainLined: undefined,
  activeCurtainAdjustment: -1,
  isCushionSmall: undefined,
  cushionHasZip: undefined,
  isCoversDecoAlterationSelected: false,
  activeEmbroideryFontSize: -1,
  activeEmbroideryDrawingSize: -1,
  isDrawingFull: undefined,
  isDrawingEasy: undefined,
  displayButtons: false,
  selectedFabric: '',
  selectedTypeOfWork: '',
  isFurSelected: false,
  upcyclingCategories: [],
  upcyclingItems: [],
  suitPieces: [],
  suitProblems: [],
  suitItems: [],
  suitPieceLinings: {},
  suitPiecesEmbroideries: {},
  suitPiecesUpcycling: {},
  sofaParts: [],
  sofaPartsSubTypes: {},
  sofaPartsItems: {},
  sofaPartsNumber: {},
  selectedZipcode: '',
  customerComment: '',
  hemCentimeters: 0,
  leftHemCentimeters: 0,
  rightHemCentimeters: 0,
  selectedSizeBag: '',
  selectedProcess: '',
  embroideryPackageTop: '',
  embroideryPackageFont: '',
  embroideryPackageWhere: '',
  embroideryPackageFontSize: '',
  embroideryPackageColor: 'black',
  embroideryPackageMessage: '',
  embroideryPackageDrawing: '',
  embroideryPackageDrawingSize: '',
  knitNeed: '',
  knitTearOption: '',
  pantHemStyle: '',
  weddingDate: '',
};

export default function getInitialState(t, preSelectedStateValues = {}) {
  return {
    ...initialState,
    ...preSelectedStateValues,
    embroideries: getList(embroideries, t),
    embroideriesPackage: getList(embroideriesPackage, t),
    curtainAlterations: getList(curtainAlterations, t),
    curtainAlterationsPackage: getList(curtainAlterationsPackage, t),
    curtainRepairs: getList(curtainRepairs, t),
    cushionAlterations: getList(cushionAlterations, t),
    linensProblems: getList(linensProblems, t),
    linensAlterations: getList(linensAlterations, t),
    linensSizes: getList(linensSizes, t),
    linensWhere: getList(linensWhere, t),
    tableClothesAlterations: getList(tableClothesAlterations, t),
    sofaAlterations: getList(sofaAlterations, t),
    chairAlterations: getList(chairAlterations, t),
  };
}

export {
  getList, initialState, curtainAdjustments, curtainAlterations, curtainAlterationsPackage, curtainRepairs, cushionAlterations,
  embroideries, embroideriesPackage, linensProblems, linensAlterations, linensSizes, linensWhere, tableClothesAlterations, sofaAlterations, chairAlterations,
};
